<template>
  <div id="kiosk-confirm-page" class="row w-100 justify-content-center">
    <div class="col-12 col-md-9 col-lg-8 text-left">
      <div class="font-weight-bold mb-2" style="color:var(--primary-color); letter-spacing:1.4px; font-size:.75rem; text-transform:uppercase;">
        <i class="fa fas fa-user-check mr-1"></i>
        Confirm your check-in
      </div>
      <h1 class="mb-2">Is this you?</h1>
      <p class="mb-4">Please confirm this is your appointment before checking in.</p>

      <div class="bg-white p-4 mb-3" style="border:1px solid #EEE; border-radius:14px; box-shadow:0 4px 16px rgba(0,0,0,.08);">
        <div class="font-weight-bold" style="font-size:1.125rem;">{{ group.clientFullName }}</div>
        <div class="text-muted mt-1" style="font-size:1rem;" v-if="group.petNames && group.petNames.length">{{ group.petNames.join(' &amp; ') }}</div>
        <div class="text-muted mt-1" style="font-size:1rem;">{{ formatTime(group.startLocal) }}</div>
      </div>

      <div v-if="error" class="text-danger p2 mt-3">{{ error }}</div>

      <div class="row align-items-center mt-4">
        <div class="col-4 text-left">
          <button type="button" class="btn btn-outline-secondary" :disabled="submitting" @click="$emit('back')">Cancel</button>
        </div>
        <div class="col-8 text-right">
          <button type="button" class="btn btn-primary" :disabled="submitting" @click="submit">
            {{ submitting ? 'Checking in…' : 'Yes, that\'s me' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WebApi } from '@/services/WebApi'
import { ErrorHelper } from '@/helpers/ErrorHelper'

export default {
  name: 'KioskConfirm',
  props: {
    group: { type: Object, required: true }
  },
  data () {
    return { submitting: false, error: '' }
  },
  methods: {
    formatTime (iso) {
      try {
        const d = new Date(iso)
        return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
      } catch (e) { return iso }
    },
    submit () {
      const self = this
      self.submitting = true
      self.error = ''
      WebApi.post('Kiosk/SignIn', {
        appointmentGroupId: self.group.appointmentGroupId,
        clientId: self.group.clientId,
        signatureText: null
      })
        .then(response => { self.$emit('signed-in', response.data) })
        .catch(error => {
          const status = error.response && error.response.status
          if (status === 401 || status === 403) {
            self.$emit('unauthorized')
          } else {
            self.error = ErrorHelper.getError(error)
          }
        })
        .finally(() => { self.submitting = false })
    }
  }
}
</script>

<style scoped>
@media (max-width: 576px) {
  #kiosk-confirm-page h1 { font-size: 1.375rem !important; }
  #kiosk-confirm-page p,
  #kiosk-confirm-page .p2 { font-size: .8125rem; }
}
</style>
